import React, { FC, useRef } from 'react';
import { LazyImage as RcLazyImage } from 'react-lazy-images';
import classNames from 'classnames';

import GradientCover from '../GradientCover';

import { LazyOnlyImageProps } from './interfaces';

import useStyles from './style';

const LazyImage: FC<LazyOnlyImageProps> = ({
  isLoadError,
  setIsLoadError,
  handleLoadError,
  src,
  alt,
  loading,
  token,
  children,
  debounceLoadMs = 300,
  ...rest
}) => {
  const classes = useStyles();

  const imageRef = useRef<Nullable<HTMLImageElement>>(null);

  const placeholder = <GradientCover token={token}>{children}</GradientCover>;

  return (
    <RcLazyImage
      src={src}
      debounceDurationMs={debounceLoadMs}
      error={() => placeholder}
      placeholder={({ ref }) => (
        <div
          ref={ref}
          className={classNames('imagePlaceholder intrinsic-item', classes.imagePlaceholder)}
        />
      )}
      actual={({ imageProps }) =>
        isLoadError ? (
          placeholder
        ) : (
          <img
            loading={loading}
            {...imageProps}
            className={classNames('imageActual intrinsic-item animated fadeIn')}
            alt={alt}
            ref={imageRef}
            onLoad={() => setIsLoadError(false)}
            onError={handleLoadError}
          />
        )
      }
      {...rest}
    />
  );
};

export default LazyImage;
